module.exports = __webpack_public_path__ + "static/media/higuchi-building-8.b5f200e3.jpg";